import {
  INITIAL_F2F_SECTION_LAYOUTS,
  SectionLayoutGroup,
} from "@/pages/app/provider/patient/patient-list/patient-chart-new/patient-visit-note/encounter/note-forms/initial-f2f";
import {
  NOTE_PREVIEW_SCREENING_HEADING,
  NOTE_PREVIEW_SCREENING_SECTION_KEY,
} from "./note-preview-constant";
import { NotePreviewLineGroup } from "./note-preview-types";

export interface NotePreviewLayoutBlock {
  /** Uppercase heading printed once above the groups that share it. */
  heading?: string;
  groups: NotePreviewLineGroup[];
}

const sameTitle = (a: string, b: string) =>
  a.trim().toLowerCase() === b.trim().toLowerCase();

/**
 * Orders a section's line groups the way the form lays them out and inserts the
 * form's headings. Groups the layout does not know keep their order at the end.
 */
/** Completed screeners ("AAQ II: Score 4") under the note screen's heading; notes and typed assessments stay below. */
const arrangeScreening = (
  groups: NotePreviewLineGroup[]
): NotePreviewLayoutBlock[] => {
  const screeners = groups.filter((group) => !!group.title && !group.isInline);
  const others = groups.filter((group) => !screeners.includes(group));
  return [
    ...(screeners.length
      ? [{ heading: NOTE_PREVIEW_SCREENING_HEADING, groups: screeners }]
      : []),
    ...(others.length ? [{ groups: others }] : []),
  ];
};

export const arrangeByLayout = (
  sectionKey: string,
  groups: NotePreviewLineGroup[]
): NotePreviewLayoutBlock[] | undefined => {
  if (sectionKey === NOTE_PREVIEW_SCREENING_SECTION_KEY)
    return arrangeScreening(groups);
  const layout: SectionLayoutGroup[] | undefined =
    INITIAL_F2F_SECTION_LAYOUTS[sectionKey];
  if (!layout) return undefined;

  const remaining = [...groups];
  const blocks: NotePreviewLayoutBlock[] = [];
  const push = (heading: string | undefined, group: NotePreviewLineGroup) => {
    const last = blocks[blocks.length - 1];
    if (last && last.heading === heading) last.groups.push(group);
    else blocks.push({ heading, groups: [group] });
  };

  layout.forEach((def) => {
    for (let index = 0; index < remaining.length;) {
      const group = remaining[index];
      if (group.title && sameTitle(group.title, def.title)) {
        push(def.heading, group);
        remaining.splice(index, 1);
      } else index += 1;
    }
  });
  remaining.forEach((group) => push(undefined, group));
  return blocks;
};
